import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import WWO from "../views/WWO.vue";
import Insights from "../views/Insights.vue";
import InsightDetail from "../views/InsightDetail.vue";
import About from "../views/About.vue";
//import People from "../views/People.vue";
import Contact from "../views/Contact.vue";
import NewsDetail from "../views/NewsDetail.vue";
import DataVoucher from "../views/DataVoucher.vue";
import DataVoucherInquiry from "../views/DataVoucherInquiry.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/wwo",
    name: "WWO",
    component: WWO,
  },
  {
    path: "/insights",
    name: "Insights",
    component: Insights,
  },
  {
    path: "/insight/:id",
    name: "InsightDetail",
    component: InsightDetail,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  // {
  //   path: "/people",
  //   name: "People",
  //   component: People
  // },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/news/:id",
    name: "NewsDetail",
    component: NewsDetail,
  },
  {
    path: "/datavoucher/inquiry",
    name: "DataVoucherInquiry",
    component: DataVoucherInquiry,
  },
  {
    path: "/datavoucher",
    name: "DataVoucher",
    component: DataVoucher,
  },
  {
    path: "*",
    redirect: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
